module.exports = "/React/dist/711499250cd880195c9081da8ceef355.png";